export const ARTICLE_ID_ON_CAST_MEMBERS = '2841331'
export const ARTICLE_ID_ON_MASS_MESSAGES = '5344653'
export const ARTICLE_ID_ON_IP_BLACK_WHITE_LIST = '2872599'
export const ARTICLE_ID_ON_DOMAIN_REDIRECTS = '2060721'
export const ARTICLE_ID_ON_PHOTOSETS = '4062883'
export const ARTICLE_ID_ON_PROMOTIONS = '3895897'
export const ARTICLE_ID_ON_STORIES = '3896144'
export const ARTICLE_ID_ON_WALLET_ACTIVITY = '5125402'
export const ARTICLE_ID_ON_CHAT_ACCESS_SETTINGS = '4993817'
export const ARTICLE_ID_ON_LIVESTREAM = '6971185'
export const ARTICLE_ID_ON_MAILING_LIST = '5354310'
export const ARTICLE_ID_ON_OUTGOING_NOTIFICATIONS = '8261180'
export const ARTICLE_ID_ON_AUTO_POSTS = '5946802'
export const ARTICLE_ID_ON_THE_VAULT = '5578020'
export const ARTICLE_ID_ON_HIDING_SCHEDULED_CONTENT = '5733981'
export const ARTICLE_ID_ON_WATERMARKS = '8647086'
export const ARTICLE_ID_ON_CUSTOM_PAGES = '1007376'
export const ARTICLE_ID_ON_LOGOS_AND_ICONS = '5460625'
export const ARTICLE_ID_ON_PAYOUT_METHODS = '1007435'
export const ARTICLE_ID_ON_STORE = '7126563'
export const ARTICLE_ID_ON_SHIPPING_ZONES = '8161102'
export const ARTICLE_ID_ON_AGE_VERIFICATION_PRIVACY_POLICY = '9362106'
export const ARTICLE_ID_ON_SEO = '7153529'
export const ARTICLE_ID_ON_SOCIAL_IMAGE = '9385640'
export const ARTICLE_ID_ON_CHAT = '4993817'
export const ARTICLE_ID_ON_PAYOUT_BALANCES = '9562018'
export const ARTICLE_ID_ON_PAYOUT_HOLDS = '9653247'
export const ARTICLE_ID_ON_CONTENT_CATEGORIES = '9740301'
export const ARTICLE_ID_ON_REPOST = '9922610'
export const ARTICLE_ID_ON_ORIGINAL_CONTENT_STORAGE = '9912315'
export const ARTICLE_ID_ON_BLUR_WHEN_LOCKED = '9926161'
export const ARTICLE_ID_ON_SAVED_REPLIES = '10138724'
export const ARTICLE_ID_ON_POLLS = '10276390'
export const ARTICLE_ID_ON_SFW_CHECKBOX = '10292085'
export const ARTICLE_ID_ON_COLLECTIONS_AND_CONTENT_TAGS = '1448070'
export const ARTICLE_ID_ON_CREATOR_REFERRALS = '1007415'
export const ARTICLE_ID_ON_THUMBNAILS = '10570994'
export const ARTICLE_ID_ON_VIDEO_DRM = '10570537'
export const ARTICLE_ID_ON_CHARGEBACK_BLOCK = '1007436'
export const ARTICLE_ID_ON_VOID_BLOCK = '1007431'
export const ARTICLE_ID_ON_REFUND_BLOCK = '4442479'
export const ARTICLE_ID_ON_SCANNING_QR_CODE = '11037868'
export const ARTICLE_ID_ON_ACCOUNT_SHARING_DETECTION = '11482594'
export const ARTICLE_ID_ON_FREE_DOWNLOAD_LIMIT = '1187457'
export const ARTICLE_ID_ON_VR_VIDEOS = '11953574'
export const ARTICLE_ID_ON_SWITCH_MEMBERSHIP = '11067822'
export const ARTICLE_ID_ON_MEMBER_WALLET = '12335689'
export const ARTICLE_ID_ON_RCV = '12771816'
export const ARTICLE_ID_ON_PAYMENT_LIMIT_REACHED = '12802634'
export const ARTICLE_ID_ON_MEMBERSHIPS = '8617614'
export const ARTICLE_ID_ON_PAYMENT_METHODS_RISK = '12959062'
export const ARTICLE_ID_ON_MEMBER_SHADOW_BANNED = '12831212'
